import { numeral } from 'numeral';

// ----------------------------------------------------------------------

export function fNumber(number) {
    return numeral(number).format();
}

export function fCurrency(number) {
    const format = number ? numeral(number).format('$0,0.00') : '';

    return result(format, '.00');
}

export function fPercent(number) {
    const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

    return result(format, '.0');
}

export function fShortenNumber(number) {
    const format = number ? numeral(number).format('0.00a') : '';

    return result(format, '.00');
}

export function fData(number) {
    const format = number ? numeral(number).format('0.0 b') : '';

    return result(format, '.0');
}

function result(format, key = '.00') {
    const isInteger = format.includes(key);

    return isInteger ? format.replace(key, '') : format;
}

export function fSize(number) {
    //   return numeral(number).format(number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    // const size = new Intl.NumberFormat('en-US');
    const size = new Intl.NumberFormat('en-IN');
    return size.format(number);
}


export function fSizeNew(number) {
    if (number === null || number === undefined) {
        return '0.00';
    }

    const formattedNumber = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number.toFixed(2));

    return formattedNumber;
}

export function formatNumberWithPostfix(number) {
    if (number === 0) return "0";

    const postfixes = ["", "K", "M"];
    const divisor = 1000;
    let magnitude = 0;
    let isNegative = false;

    if (number < 0) {
        isNegative = true;
        number = Math.abs(number);
    }

    while (number >= divisor && magnitude < postfixes.length - 1) {
        number /= divisor;
        magnitude += 1;
    }

    const formattedNumber = (isNegative ? "-" : "") + number.toFixed(1);
    return formattedNumber + postfixes[magnitude];
}

export function fPercentage(number) {
    return `${number.toFixed(2)}%`;
}

export function fSizeNew1(number) {
    // Ensure the input is a valid number, default to 0 if not
    const parsedNumber = parseFloat(number);

    // eslint-disable-next-line no-restricted-globals
    if (isNaN(parsedNumber)) {
        return '0.00';
    }

    // Format the number with 2 decimal places without grouping separators
    const formattedNumber = new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true, // Disable grouping separators like commas
    }).format(parsedNumber);

    return formattedNumber;
}